import { render, staticRenderFns } from "./DeclarationImport.vue?vue&type=template&id=46b9ab20&"
import script from "./DeclarationImport.vue?vue&type=script&lang=js&"
export * from "./DeclarationImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports